import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
class Navigation extends Component {
    render() {
        return (
            <div>
                        {/*::menu part start::*/}
                <header className="main_menu home_menu">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12">
                        <nav className="navbar navbar-expand-lg navbar-light">
                        <NavLink className="navbar-brand" exact to="/"><img src="img/logo.png" alt="logo" /> </NavLink>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div className="collapse navbar-collapse main-menu-item" id="navbarNav">
                            <ul className="navbar-nav">
                            <li className="nav-item active">
                               <NavLink exact activeStyle={{color:"#ff3334"}} className="nav-link" to="/">Home</NavLink>
                            </li>
                            <li className="nav-item">
                            <NavLink className="nav-link" to="/about">about</NavLink>
                            </li>
                            <li className="nav-item">
                            <NavLink className="nav-link" to="/service">Services</NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                blog
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <NavLink className="dropdown-item" to="/blog">Blog</NavLink>
                                <NavLink className="dropdown-item" to="/blogdetails">Single Blog</NavLink>
                               
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                pages
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <NavLink className="dropdown-item" to="/project">Project</NavLink>
                                <NavLink className="dropdown-item" to="/apartments">Apartment</NavLink>
                               
                                </div>
                            </li>
                            <li className="nav-item">
                            <NavLink className="nav-link" to="/contact">Contact us</NavLink>
                            </li>
                            </ul>
                        </div>
                        </nav>
                    </div>
                    </div>
                </div>
                </header>
                {/*::menu part end::*/}
            </div>
        );
    }
}

export default Navigation;